mutation deleteContact($customerId: ID!, $contactId: ID!) {
  deleteContact(customerId: $customerId, contactId: $contactId)
}
